import type { TypePolicies } from '@apollo/client';

/**
 * Custom Apollo cache behavior
 */
export const sessionTypePolicies: TypePolicies = {
  Session: { keyFields: ['sessionId'] },
};
